import {
  TASKPANE_API_ENDPOINTS,
  getApiAuthCredentials,
  createApiHeaders,
  createApiFetchOptions,
  createApiUrl,
} from "../services/apiConfig";
import logger from "../../logger";

export const fetchAllFunds = async () => {
  try {
    const { accessToken, orgId, orgUnitId } = await getApiAuthCredentials();
    const url = await createApiUrl(TASKPANE_API_ENDPOINTS.ALL_FUNDS);
    const headers = createApiHeaders(accessToken, orgId, orgUnitId);
    const options = createApiFetchOptions("GET", headers);

    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error(
        "API request failed with status " + response.status + " " + response.statusText
      );
    }

    const data = await response.json();

    if (!data) {
      throw new Error("No data returned from API");
    }

    let fundsArray = [];
    if (Array.isArray(data)) {
      fundsArray = data;
    } else if (data.data && Array.isArray(data.data)) {
      fundsArray = data.data;
    } else if (data.funds && Array.isArray(data.funds)) {
      fundsArray = data.funds;
    } else if (data && typeof data === "object") {
      fundsArray = [data];
    }

    return fundsArray;
  } catch (error) {
    logger.error("Error fetching funds:", error);
    throw error;
  }
};

export const fetchSelectedFund = async (fundId) => {
  try {
    const { accessToken, orgId, orgUnitId } = await getApiAuthCredentials();
    const url = await createApiUrl(TASKPANE_API_ENDPOINTS.FUND_BY_ID, { fundId: fundId.trim() });
    const headers = createApiHeaders(accessToken, orgId, orgUnitId);
    const options = createApiFetchOptions("GET", headers);

    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error(
        "API request failed with status " + response.status + " " + response.statusText
      );
    }

    const result = await response.json();

    if (!result) {
      throw new Error("No data returned from API");
    }

    let fundObject = null;

    if (result && typeof result === "object") {
      if (result.data && typeof result.data === "object" && !Array.isArray(result.data)) {
        fundObject = result.data;
      } else if (result.data && Array.isArray(result.data) && result.data.length > 0) {
        fundObject = result.data[0];
      } else if (Array.isArray(result) && result.length > 0) {
        fundObject = result[0];
      } else if (typeof result === "object" && !Array.isArray(result) && !result.data) {
        fundObject = result;
      }
    }

    if (!fundObject || typeof fundObject !== "object" || Array.isArray(fundObject)) {
      throw new Error("No fund data found in API response");
    }

    return fundObject;
  } catch (error) {
    logger.error("Error fetching selected fund:", error);
    throw error;
  }
};
